import React, { Fragment, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faUser } from "@fortawesome/free-solid-svg-icons";
import { staffRoleFormatter } from '../lib/formatter';
import * as api from '../api';

const Header = ({
  history
}) => {
  const { t } = useTranslation();
  const [ isOpen, setIsOpen ] = useState(false);
  const { name, role } = useSelector(state => state.header);

  const logout = async () => {
    try {
      await api.logout();
    }
    finally {
      localStorage.removeItem('api_key');
      localStorage.removeItem('hotel_id');
      history.replace('/login');
    }
  };

  return (
    <Fragment>
      <div className='header'>
        <div className='header-img'>
          {/* <img src='../../assets/images/main_logo.png' alt='main_logo'></img> */}
          <p className='header-title'>{t('company_title')}</p>
        </div>
        <div className='header-info'>
          <Dropdown className='header-dropdown-wrap'
            onMouseLeave={() => setIsOpen(false)}
            onClick={e => e.stopPropagation()}
          >
            <Dropdown.Toggle variant="success" id="dropdown-basic" onClick={e => e.stopPropagation()} onMouseOver={() => setIsOpen(true)}>
              <FontAwesomeIcon icon={faUser} />
            </Dropdown.Toggle>
            <Dropdown.Menu show={isOpen}>
              <div className='user-info'>
                <p>{name}</p>
                <span>{staffRoleFormatter(role)}</span>
              </div>
              <div className='pt-8'>
                <div className='dropdown-item-delete' onClick={() => logout()}>
                  <span>{t('button.logout')}</span>
                  <FontAwesomeIcon icon={faSignOutAlt} className='logout-icon'></FontAwesomeIcon>
                </div>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </Fragment>
  );
}

export default Header;